import { Dialog as BaseDialog } from '@base-ui/react/dialog';

import { cn } from '@/lib/cn';

type Props = {
  children: React.ReactNode;
  className?: string;
};

const DialogDescription = ({ children, className }: Props) => {
  return (
    <BaseDialog.Description
      className={cn('text-sm font-medium leading-[1.2]', className)}
    >
      {children}
    </BaseDialog.Description>
  );
};

export default DialogDescription;
